export const FOO = 100;

export const SIGN_UP_URL = "dsd_signUp_course";
export const SIGN_UP_STEP = "signUpStep";
export const SIGN_UP_SOCIAL = "socialSignUp";
export const LOGIN_MISSING_META = "stepperMissingMeta";
export const LOGIN_SOCIAL = "socialLogin";